import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles/global.css";
import "./styles/accent.css";
// [O1] Akcent palety w ciemnym motywie (plik generowany z utils/kontrastKolorow.js) — MUSI stać po accent.css.
import "./styles/accentCiemny.css";
import "./styles/zindex.css";
import "./styles/utilities.css";
import "./styles/responsive.css";
import "./styles/ostatnioOdwiedzone.css";
// [polecenie właściciela 2026-09-16] Blokada wydruku obszarów z danymi wrażliwymi — reguła `@media print`
// musi objąć CAŁY dokument (także okna portalowane do <body>), więc stoi w arkuszu globalnym.
import "./styles/ochronaEkranu.css";
/*
 * [13.09 §12.4] Arkusze wspólnych komponentów — ściągnięte do paczki głównej, żeby budowanie
 * przestało wypisywać 27 ostrzeżeń „Conflicting order" (przy `CI=true` każde z nich wywraca
 * build). MUSI stać PO arkuszach globalnych: relacja „globalne najpierw, moduły potem" jest
 * założeniem kilkudziesięciu arkuszy (`composes: … from global`). Uzasadnienie, pomiar i cena:
 * `src/styles/wspolneArkusze.js`.
 */
import "./styles/wspolneArkusze";
import App from "./App";
import { BackendStatusProvider } from "./context/BackendStatusContext";
import ServerDownPage from "./pages/ServerDownPage";
import { AuthProvider } from "./context/AuthContext";
import { BrandingProvider } from "./context/BrandingContext";
import { NotificationProvider } from "./context/NotificationContext";
import { UIProvider } from "./context/UIContext";
import { TeamsChatProvider } from "./context/TeamsChatContext";
import { LoadingProvider } from "./context/LoadingContext";
import { AccessibilityProvider } from "./context/AccessibilityContext";
import { PersonalizationProvider } from "./context/PersonalizationContext";
import GlobalLoader from "./components/GlobalLoader/GlobalLoader";
import reportWebVitals from "./reportWebVitals";
import { zainicjujPwa } from "./utils/pwa";
import { przechwycOdpowiedzO365 } from "./services/o365LoginService";

// ── Globalna siatka bezpieczeństwa na niewyłapane odrzucenia ──────────────────────────────
// Błędy axios obsługiwane globalnie (interceptor / BackendStatus / komponenty): 401 (sesja lub
// integracja Microsoft), anulowane żądania (AbortController) oraz błędy sieci. NIE powinny
// wywoływać overlay'a błędów CRA ani crashować aplikacji. Realne błędy (nie-axios, 4xx/5xx
// inne niż 401) przechodzą dalej i pozostają widoczne.
window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  if (!reason) return;
  const isAxios = reason.isAxiosError === true || reason.name === "AxiosError";
  const isCanceled = reason.name === "CanceledError" || reason.code === "ERR_CANCELED";
  const status = reason.response && reason.response.status;
  // Bramkowe 5xx (502/503/504) = backend padł za żywym nginx. Obsługiwane globalnie przez
  // down-detektor, więc nie pozwalamy im wywalać overlay'a błędów CRA podczas awarii.
  const isGatewayDown = status === 502 || status === 503 || status === 504;
  if (isCanceled || (isAxios && (status === 401 || isGatewayDown || !reason.response))) {
    event.preventDefault();
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("[axios] obsłużone odrzucenie:", reason.config && reason.config.url, status || reason.code);
    }
  }
});

// ── Powrót z logowania Office 365 (zgłoszenie „nie mogę zalogować się z telefonu") ───────
// MUSI być PRZED renderem. Adresem powrotu jest „/", a trasa „/" przy braku zalogowania
// renderuje <Navigate to="/logowanie">. Cel przekierowania nie ma fragmentu adresu, więc
// React Router wyrzuciłby `#code=…` z odpowiedzią Microsoftu, zanim ekran logowania zdąży
// się zamontować. Tu fragment jest zdejmowany z adresu i zapamiętywany dla LoginPage.
przechwycOdpowiedzO365();

// ── Nakładka PWA (brief 2026-09-02, poz. 6) ──────────────────────────────────────────────
// Wołane PRZED renderem, bo przeglądarka wysyła `beforeinstallprompt` raz i zwykle zanim React
// zdąży zamontować pulpit. Nasłuch wpięty dopiero w komponencie przegapiłby to zdarzenie
// i pokazywałby instrukcję ręczną komuś, kto mógłby kliknąć jeden przycisk.
zainicjujPwa();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <BackendStatusProvider offlineFallback={<ServerDownPage />}>
        <BrandingProvider>
        <AuthProvider>
          <NotificationProvider>
            <UIProvider>
              <AccessibilityProvider>
                <PersonalizationProvider>
                  <TeamsChatProvider>
                    <LoadingProvider>
                      <GlobalLoader />
                      <App />
                    </LoadingProvider>
                  </TeamsChatProvider>
                </PersonalizationProvider>
              </AccessibilityProvider>
            </UIProvider>
          </NotificationProvider>
        </AuthProvider>
        </BrandingProvider>
      </BackendStatusProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
